/**
 * This file was automatically generated.
 *
 * PLEASE DO NOT EDIT MANUALLY
 *
 * Refer to scripts/colors/README.md for information.
 *
 * This file should define ALL the CSS variables related to colors.
 *
 * This file is in turn used by the theme/<brand>/tokens.js file as an
 * indirection to abstract some combinations and semantics.
 *
 * For example, "--pnr-primary-background-top" should never be used on
 * its own by any component themes. However, it is used by tokens to
 * create an abstraction for the Primary button background color, and
 * tokens is the one that is being used by themes/<brand>/button.js
 */
export default {
  /**
   * New colors
   */
  "--pnr-neutral05": "#f9f7f6",
  "--pnr-neutral10": "#f3f2f2",
  "--pnr-neutral20": "#e7e5e4",
  "--pnr-neutral30": "#cfcac7",
  "--pnr-neutral40": "#b0aaa7",
  "--pnr-neutral50": "#8f8784",
  "--pnr-neutral60": "#736c69",
  "--pnr-neutral70": "#544f4d",
  "--pnr-neutral80": "#403c3a",
  "--pnr-neutral90": "#2e2b2a",
  "--pnr-neutral100": "#181616",
  "--pnr-yellow10": "#faf6cf",
  "--pnr-yellow20": "#f7e790",
  "--pnr-yellow30": "#ffcd41",
  "--pnr-yellow40": "#d9a514",
  "--pnr-yellow50": "#b3870e",
  "--pnr-yellow60": "#946613",
  "--pnr-yellow70": "#70491c",
  "--pnr-yellow80": "#54341f",
  "--pnr-yellow90": "#38251b",
  "--pnr-yellow100": "#1c1613",
  "--pnr-indigo10": "#f4f2fc",
  "--pnr-indigo20": "#e3defc",
  "--pnr-indigo30": "#cbc0fc",
  "--pnr-indigo40": "#b6a1fc",
  "--pnr-indigo50": "#9378f5",
  "--pnr-indigo60": "#6f5dd4",
  "--pnr-indigo70": "#5a469b",
  "--pnr-indigo80": "#352b6b",
  "--pnr-indigo90": "#27204f",
  "--pnr-indigo100": "#171230",
  "--pnr-violet10": "#f6f2f7",
  "--pnr-violet20": "#f2daf7",
  "--pnr-violet30": "#ebb8f5",
  "--pnr-violet40": "#d997e5",
  "--pnr-violet50": "#bb70cc",
  "--pnr-violet60": "#9c4bab",
  "--pnr-violet70": "#823291",
  "--pnr-violet80": "#5a1e64",
  "--pnr-violet90": "#3f1c45",
  "--pnr-violet100": "#1f1121",
  "--pnr-purple10": "#faf2f8",
  "--pnr-purple20": "#f5dcee",
  "--pnr-purple30": "#f0b6df",
  "--pnr-purple40": "#eb8dd4",
  "--pnr-purple50": "#d962bb",
  "--pnr-purple60": "#b52892",
  "--pnr-purple70": "#941a75",
  "--pnr-purple80": "#700f55",
  "--pnr-purple90": "#4e0e3e",
  "--pnr-purple100": "#300826",
  "--pnr-pink10": "#faf2f4",
  "--pnr-pink20": "#fadce4",
  "--pnr-pink30": "#fcb6c9",
  "--pnr-pink40": "#f78daa",
  "--pnr-pink50": "#e5678a",
  "--pnr-pink60": "#c83255",
  "--pnr-pink70": "#9b2341",
  "--pnr-pink80": "#6e142d",
  "--pnr-pink90": "#4f1626",
  "--pnr-pink100": "#291015",
  "--pnr-green10": "#edf5f0",
  "--pnr-green20": "#cae8d6",
  "--pnr-green30": "#9ad6b2",
  "--pnr-green40": "#60bf86",
  "--pnr-green50": "#309c5f",
  "--pnr-green60": "#007545",
  "--pnr-green70": "#14613c",
  "--pnr-green80": "#184229",
  "--pnr-green90": "#11301e",
  "--pnr-green100": "#091a10",
  "--pnr-orange10": "#fcf2eb",
  "--pnr-orange20": "#fcdac7",
  "--pnr-orange30": "#ffbb94",
  "--pnr-orange40": "#ff9657",
  "--pnr-orange50": "#e66114",
  "--pnr-orange60": "#bd4a08",
  "--pnr-orange70": "#943600",
  "--pnr-orange80": "#662804",
  "--pnr-orange90": "#402117",
  "--pnr-orange100": "#1f1410",
  "--pnr-coral10": "#fcf4f2",
  "--pnr-coral20": "#fcddd9",
  "--pnr-coral30": "#ffb1a6",
  "--pnr-coral40": "#ff8b78",
  "--pnr-coral50": "#e55e47",
  "--pnr-coral60": "#c93b24",
  "--pnr-coral70": "#9c2716",
  "--pnr-coral80": "#73190b",
  "--pnr-coral90": "#52140b",
  "--pnr-coral100": "#2b0c08",
  "--pnr-blue10": "#edf3f7",
  "--pnr-blue20": "#d1e3f0",
  "--pnr-blue30": "#a5cce5",
  "--pnr-blue40": "#7ab5de",
  "--pnr-blue50": "#4b94c4",
  "--pnr-blue60": "#1e6fa6",
  "--pnr-blue70": "#00558e",
  "--pnr-blue80": "#033e66",
  "--pnr-blue90": "#082e47",
  "--pnr-blue100": "#071621",
  "--pnr-lime10": "#eaf7da",
  "--pnr-lime20": "#d4f0b1",
  "--pnr-lime30": "#a8d971",
  "--pnr-lime40": "#75bf39",
  "--pnr-lime50": "#55a31d",
  "--pnr-lime60": "#3e7d0e",
  "--pnr-lime70": "#305c0e",
  "--pnr-lime80": "#264211",
  "--pnr-lime90": "#1d2e10",
  "--pnr-lime100": "#121a00",
  "--pnr-turquoise10": "#ebf5f4",
  "--pnr-turquoise20": "#c7e7ed",
  "--pnr-turquoise30": "#81d7e6",
  "--pnr-turquoise40": "#45bad1",
  "--pnr-turquoise50": "#1599b3",
  "--pnr-turquoise60": "#067891",
  "--pnr-turquoise70": "#09576b",
  "--pnr-turquoise80": "#0c434d",
  "--pnr-turquoise90": "#102e33",
  "--pnr-turquoise100": "#0f181a",
  "--pnr-pure-black": "#000000",
  "--pnr-black": "#141414",
  "--pnr-white": "#ffffff",
  "--pnr-wf-red": "#d71e28",

  /**
   * Legacy colors
   *
   * The following colors are used by the legacy CEO
   * theme (the default colors that used to come with
   * Pioneer WFRIA v3). They are provided here for
   * backward compatibility only.
   */
  "--pnr-primary": "var(--pnr-blue70)",
  "--pnr-secondary": "#d34600",
  "--pnr-tertiary": "#675b53",
  "--pnr-background": "#f7f7f5",
  "--pnr-messaging-error": "#bb0700",
  "--pnr-messaging-success": "#00802c",
  "--pnr-messaging-warning": "#f0b316",
  "--pnr-messaging-information": "#5174b8",
  "--pnr-messaging-error-light": "#ffe5e4",
  "--pnr-messaging-success-light": "#e5f2e9",
  "--pnr-messaging-warning-light": "#fdf7e7",
  "--pnr-messaging-information-light": "#edf1f8",
  "--pnr-messaging-utility-light": "#eeeff0",
  "--pnr-focus-light": "#6da003",
  "--pnr-focus-dark": "#4d7011",

  /**
   * Primary action colors
   */
  "--pnr-primary-text": "#fff",
  // inactive state
  "--pnr-primary-background-top": "#3277a4",
  "--pnr-primary-background-bottom": "#0b6198",
  // hover state
  "--pnr-primary-hover-background-top": "#2f6e97",
  "--pnr-primary-hover-background-bottom": "#0b4e79",
  // pressed / active state
  "--pnr-primary-active-background-top": "#0b4e79",
  "--pnr-primary-active-background-bottom": "#2f6e97",

  /**
   * Secondary action colors
   */
  "--pnr-secondary-border": "#8d8d8d",
  "--pnr-secondary-text": "#000",
  // inactive state
  "--pnr-secondary-background-top": "#fff",
  "--pnr-secondary-background-bottom": "#f0f1f2",
  // hover state
  "--pnr-secondary-hover-background-top": "#fff",
  "--pnr-secondary-hover-background-bottom": "#dbddde",
  // pressed / active state
  "--pnr-secondary-active-background-top": "#dbddde",
  "--pnr-secondary-active-background-bottom": "#fff",

  /**
   * Tertiary action colors
   */
  "--pnr-tertiary-text": "var(--pnr-blue70)"
};